import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditCustomerComponent } from '../edit-customer/edit-customer.component';
import { Customer } from 'src/app/test/customer.model';

@Component({
  selector: 'lsu-show-customer',
  templateUrl: './show-customer.component.html',
  styleUrls: ['./show-customer.component.scss']
})
export class ShowCustomerComponent implements OnInit {

  @Input() customer;
  formGroup: any;
  constructor(public Router: Router, public afs: AngularFirestore, public fb: FormBuilder, public dialog: MatDialog, ) { }

  ngOnInit() {
    this.formGroup = this.fb.group({
      _id: this.fb.control(""),
      name: this.fb.control(""),
      phone: this.fb.control(""),
      email: this.fb.control(""),
      address: this.fb.control(""),
      notes: this.fb.control(""),
    });
  }
  // Use getters for cleaner HTML code
  get email() {
    return this.formGroup.get('email')
  }

  get name() {
    return this.formGroup.get('name')
  }

  async editCustomer(customer: any) {
    const dialogRef = this.dialog.open(EditCustomerComponent, {
      width: '350px',
      data: customer
    });
    const customerUpdated = await dialogRef.afterClosed().toPromise<Customer>()
    if (customerUpdated) {
     this.customer = customerUpdated;
    }
  }
}